module.exports = __webpack_public_path__ + "img/zhaohangerweima.795e2cd1.jpg";